function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
const normalizeRole = (role)=>{
    if (role === 'owner' || role === 'admin' || role === 'editor') {
        return role;
    }
    return 'viewer';
};
const normalizeDate = (value)=>{
    if (!value) {
        return null;
    }
    return typeof value === 'string' ? value : value.toISOString();
};
export function buildAbacPrincipal(user, organization, overrides) {
    var _memberships_orgMemberships, _memberships_projectMemberships, _memberships_teamMemberships, _memberships_envMemberships, _user_email, _user_name;
    const role = organization.role ? normalizeRole(organization.role) : undefined;
    const baseMemberships = {
        orgMemberships: role ? [
            {
                orgId: organization.id,
                role,
                owner: role === 'owner'
            }
        ] : [],
        projectMemberships: [],
        teamMemberships: [],
        envMemberships: []
    };
    const memberships = _object_spread({}, baseMemberships, overrides);
    const orgMemberships = ((_memberships_orgMemberships = memberships.orgMemberships) !== null && _memberships_orgMemberships !== void 0 ? _memberships_orgMemberships : []).map((membership)=>({
            orgId: membership.orgId,
            role: normalizeRole(membership.role),
            owner: Boolean(membership.owner)
        }));
    const projectMemberships = ((_memberships_projectMemberships = memberships.projectMemberships) !== null && _memberships_projectMemberships !== void 0 ? _memberships_projectMemberships : []).map((membership)=>{
        var _membership_source;
        return {
            projectId: membership.projectId,
            role: normalizeRole(membership.role),
            source: (_membership_source = membership.source) !== null && _membership_source !== void 0 ? _membership_source : 'user'
        };
    });
    const teamMemberships = ((_memberships_teamMemberships = memberships.teamMemberships) !== null && _memberships_teamMemberships !== void 0 ? _memberships_teamMemberships : []).map((membership)=>({
            teamId: membership.teamId,
            role: membership.role
        }));
    const envMemberships = ((_memberships_envMemberships = memberships.envMemberships) !== null && _memberships_envMemberships !== void 0 ? _memberships_envMemberships : []).map((membership)=>({
            envId: membership.envId
        }));
    const orgMemberIds = new Set();
    const orgViewerIds = new Set();
    const orgEditorIds = new Set();
    const orgAdminIds = new Set();
    const orgOwnerIds = new Set();
    for (const membership of orgMemberships){
        orgMemberIds.add(membership.orgId);
        orgViewerIds.add(membership.orgId);
        const isOwner = membership.role === 'owner' || membership.owner === true;
        if (isOwner) {
            orgOwnerIds.add(membership.orgId);
        }
        if (isOwner || membership.role === 'admin') {
            orgAdminIds.add(membership.orgId);
        }
        if (isOwner || membership.role === 'admin' || membership.role === 'editor') {
            orgEditorIds.add(membership.orgId);
        }
    }
    const projectViewerIds = new Set();
    const projectEditorIds = new Set();
    const projectAdminIds = new Set();
    for (const membership of projectMemberships){
        projectViewerIds.add(membership.projectId);
        if (membership.role === 'editor' || membership.role === 'admin' || membership.role === 'owner') {
            projectEditorIds.add(membership.projectId);
        }
        if (membership.role === 'admin' || membership.role === 'owner') {
            projectAdminIds.add(membership.projectId);
        }
    }
    const teamMemberIds = new Set();
    const teamMaintainerIds = new Set();
    for (const membership of teamMemberships){
        if (membership.role === 'maintainer') {
            teamMaintainerIds.add(membership.teamId);
        }
        if (membership.role === 'member' || membership.role === 'maintainer') {
            teamMemberIds.add(membership.teamId);
        }
    }
    return {
        id: user.id,
        // Always include the base `user` role so derived roles that key off parentRoles=["user"]
        // continue to work even when we also provide an org-scoped role like `organization_admin`.
        roles: role ? [
            "organization_".concat(role),
            'user'
        ] : [
            'user'
        ],
        attributes: {
            email: (_user_email = user.email) !== null && _user_email !== void 0 ? _user_email : '',
            name: (_user_name = user.name) !== null && _user_name !== void 0 ? _user_name : '',
            scopes: [],
            orgMemberships,
            projectMemberships,
            teamMemberships,
            envMemberships,
            orgMemberIds: [
                ...orgMemberIds
            ],
            orgViewerIds: [
                ...orgViewerIds
            ],
            orgEditorIds: [
                ...orgEditorIds
            ],
            orgAdminIds: [
                ...orgAdminIds
            ],
            orgOwnerIds: [
                ...orgOwnerIds
            ],
            projectViewerIds: [
                ...projectViewerIds
            ],
            projectEditorIds: [
                ...projectEditorIds
            ],
            projectAdminIds: [
                ...projectAdminIds
            ],
            teamMemberIds: [
                ...teamMemberIds
            ],
            teamMaintainerIds: [
                ...teamMaintainerIds
            ]
        }
    };
}
export function buildOrganizationAttributes(organization) {
    var _ref, _organization_openMembership, _organization_subscriptionTier, _organization_deletedAt;
    var _organization_privacyOptions;
    const isPrivate = (_ref = (_organization_privacyOptions = organization.privacyOptions) === null || _organization_privacyOptions === void 0 ? void 0 : _organization_privacyOptions.isPrivate) !== null && _ref !== void 0 ? _ref : true;
    return {
        organizationId: organization.id,
        isPrivate,
        openMembership: (_organization_openMembership = organization.openMembership) !== null && _organization_openMembership !== void 0 ? _organization_openMembership : false,
        subscriptionTier: (_organization_subscriptionTier = organization.subscriptionTier) !== null && _organization_subscriptionTier !== void 0 ? _organization_subscriptionTier : 'PERSONAL',
        deletedAt: normalizeDate((_organization_deletedAt = organization.deletedAt) !== null && _organization_deletedAt !== void 0 ? _organization_deletedAt : null)
    };
}
export function buildProjectAttributes(organization, project) {
    var _ref, _ref1;
    const visibility = (_ref = project === null || project === void 0 ? void 0 : project.visibility) !== null && _ref !== void 0 ? _ref : 'private';
    const normalizedVisibility = typeof visibility === 'string' ? visibility.toLowerCase() : 'private';
    const isPrivate = normalizedVisibility === 'public' ? false : true;
    return {
        organizationId: organization.id,
        visibility,
        isPrivate,
        deletedAt: normalizeDate((_ref1 = project === null || project === void 0 ? void 0 : project.deletedAt) !== null && _ref1 !== void 0 ? _ref1 : null)
    };
}
export function buildApplicationAttributes(organization, application) {
    var _ref, _ref1, _ref2;
    return {
        organizationId: organization.id,
        projectId: (_ref = application === null || application === void 0 ? void 0 : application.projectId) !== null && _ref !== void 0 ? _ref : '',
        isPrivate: (_ref1 = application === null || application === void 0 ? void 0 : application.isPrivate) !== null && _ref1 !== void 0 ? _ref1 : true,
        deletedAt: normalizeDate((_ref2 = application === null || application === void 0 ? void 0 : application.deletedAt) !== null && _ref2 !== void 0 ? _ref2 : null)
    };
}
export function buildTeamAttributes(organization, team) {
    var _ref, _ref1;
    var _organization_privacyOptions;
    const isPrivate = (_ref = (_organization_privacyOptions = organization.privacyOptions) === null || _organization_privacyOptions === void 0 ? void 0 : _organization_privacyOptions.isPrivate) !== null && _ref !== void 0 ? _ref : true;
    return {
        organizationId: organization.id,
        isPrivate,
        deletedAt: normalizeDate((_ref1 = team === null || team === void 0 ? void 0 : team.deletedAt) !== null && _ref1 !== void 0 ? _ref1 : null)
    };
}
export function buildSubscriptionAttributes(organization) {
    var _organization_subscriptionTier;
    return {
        organizationId: organization.id,
        subscriptionTier: (_organization_subscriptionTier = organization.subscriptionTier) !== null && _organization_subscriptionTier !== void 0 ? _organization_subscriptionTier : 'PERSONAL'
    };
}
export function buildPeopleAttributes(organization, extra) {
    const _ref = extra !== null && extra !== void 0 ? extra : {}, { targetUserId } = _ref, rest = _object_without_properties(_ref, [
        "targetUserId"
    ]);
    return _object_spread({
        organizationId: organization.id
    }, targetUserId ? {
        targetUserId
    } : {}, rest);
}
